import { slot_games } from "../../constants/slot_games.js";
import { lastJackpotWinner } from "../../js/api/jackpot.js";
import { userData } from "../../js/api/profile.js";
import IframeModal from "../components/IframeModal.js";
import { getCurrentBalance, updatecasinocurrency } from "../../js/api/balance.js";
import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";

let NewSlots = {
    render: async () => {
        const lastJackpotWinnerLabel = await lastJackpotWinner();
        let view = /*html*/ `
      <div class="modalHelperHolder">
        <div class="modalHelperPosition">
            <span>${_t('Zgjedh monedhen per casino')}</span>
            <select id="coinSelectorSelect">
            </select>
            <a class="submitBtn modalHandler" id="submitCoinSelected">${_t('Vazhdo')}</a>
        </div>
      </div>
      <div id="main" style="display: block; width: 100%; height: auto;">
        <iframe src="data:text/html,<h1></h1>" id="slotsIframe" frameborder="0" noresize="noresize" allow="geolocation 'self'; autoplay 'self'" scrolling="no" height="1050" style="width: 100%; overflow: hidden;"></iframe>
      </div>
    `;
        return view;
    },
    after_render: async () => {
        $("body").click(function (e) {
            if (!$(e.target).is(".modalHelperPosition,.modalHelperPosition *")) {
                $(".modalHelperHolder").removeClass("active");
            }
        });

        setCurrentBalanceForSlots();

        $("body").on("click", "#submitCoinSelected", async function (e) {
            const res = await updatecasinocurrency($("#coinSelectorSelect").val());
            alert(_t("Monedha u vendos, vazhdoni te luani!!"));
            callSliderEvent();
        });

        const access_token = localStorage.getItem('access_token');
        const $iframe = $('#slotsIframe');
        if (access_token) {
            const token = btoa(access_token);
            $iframe.attr('src', `https://xbet365.co/vbetcasino?sign=${token}`);
        } else {
            let iframe = document.getElementById('slotsIframe');
            iframe.onload = function () {
                var childWindow = iframe ? iframe.contentWindow : null;
                childWindow.addEventListener("message", (e) => {
                    var data = e.data; // hare are data sent by other window postMessage method
                    if (data && data.openLogin === true) {
                        document.getElementById("loginBtn").click();
                    }
                });
            }
            $iframe.attr('src', 'http://xbet365.co/vbetcasino');
        }

        const iframeContentWindow = document.getElementById('slotsIframe').contentWindow;
        window.addEventListener('message', message => {
            if (message.source !== iframeContentWindow) { return; }
            if (message.data && message.data.setHeight) {
                const iframe = document.getElementById("slotsIframe");
                iframe.height = message.data.setHeight;
            }
        });

    },
};

async function setCurrentBalanceForSlots() {
    var currentBalanceResult = await getCurrentBalance();

    if (currentBalanceResult.casino_currency) return;

    var coins = [];

    if (currentBalanceResult && currentBalanceResult.total_coins) {
        var allCoins = currentBalanceResult.total_coins.split("|");

        if (currentBalanceResult.total_coins.includes("|")) {
            var allCoins = currentBalanceResult.total_coins.split("|");

            for (let index = 0; index < allCoins.length; index++) {
                const coin = allCoins[index];
                const currency = coin.split(";")[0].split(".")[1];
                coins.push({
                    currency,
                    id: coin.split(";")[0].split(".")[0],
                });

                const value = coin.split(";")[1];
            }
        } else {
            if (currentBalanceResult.currency) {
                coins.push({
                    currency: currentBalanceResult.currency,
                    id: currentBalanceResult.currency_id,
                });
            } else {
                const currency = currentBalanceResult.total_coins
                    .split(";")[0]
                    .split(".")[1];
                coins.push({
                    currency,
                    id: currentBalanceResult.total_coins.split(";")[0].split(".")[0],
                });
            }
        }
    }

    renderCoins(coins);
    callSliderEvent();
}

async function renderCoins(coins) {
    coins.forEach((element) => {
        $("#coinSelectorSelect").append(`<option value="${element.id}"> 
       ${Utils.currencyCode(element.currency)}   
 </option>`);
    });
}

function callSliderEvent() {
    if ($("body .modalHelperHolder").hasClass("active")) {
        $("body .modalHelperHolder").removeClass("active");
    } else {
        $("body .modalHelperHolder").addClass("active");
    }
}

export default NewSlots;
